"use strict";
// @ts-ignore
try {
    self['workbox:range-requests:6.5.3'] && _();
}
catch (e) { }
